import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'spv2-oss-copyright',
    templateUrl: './oss-copyright.component.html',
    styleUrls: ['./oss-copyright.component.scss'],
    standalone: false
})
export class OssCopyrightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
